import { useEffect, useState } from 'react';
import { AssistantRule } from '../../../../../shared/types/assistant-rule';
import { Briefcase, ClipboardList, FileText, X } from 'lucide-react';
import { Chip } from '../../../../components/general/chip';
import { classNames } from '../../../../../shared/types/className';

export const QuickOptionsPanel = ({
    open,
    onClose,
    onSend,
    presets,
}: {
    open: boolean;
    onClose: () => void;
    onSend: (text: string) => void;
    presets: Record<string, AssistantRule[]>;
}) => {
    const [selectedCat, setSelectedCat] = useState(Object.keys(presets)[0]);

    useEffect(() => {
        if (!presets[selectedCat]) {
            setSelectedCat(Object.keys(presets)[0]);
        }
    }, [presets, selectedCat]);

    return (
        <div
            className={classNames(
                'quick-panel',
                open ? 'quick-panel--open' : 'quick-panel--closed'
            )}
            aria-hidden={!open}
        >
            {/* Header */}
            <div className="quick-panel__header">
                <div className="quick-panel__title">
                    <ClipboardList className="quick-panel__title-icon" />
                    <h4>Gestión de Licitaciones</h4>
                </div>

                <button onClick={onClose} className="quick-panel__close">
                    <X className="quick-panel__close-icon" />
                </button>
            </div>

            {/* Categories */}
            <div className="quick-panel__categories">
                {Object.keys(presets).map((cat) => (
                    <Chip
                        key={cat}
                        onClick={() => setSelectedCat(cat)}
                        active={cat === selectedCat}
                    >
                        <Briefcase className="quick-panel__chip-icon" />
                        {cat}
                    </Chip>
                ))}
            </div>

            {/* Options */}
            <div className="quick-panel__content">
                {presets[selectedCat]?.map((q: AssistantRule, idx: number) => (
                    <button
                        key={idx}
                        onClick={() => onSend(q.triggerText)}
                        className="quick-panel__option"
                    >
                        <div className="quick-panel__option-inner">
                            <FileText className="quick-panel__option-icon" />
                            <div>
                                <h3 className="quick-panel__option-title">
                                    {q.triggerText}
                                </h3>
                                <p className="quick-panel__option-subtitle">
                                    Toca para enviar al chat
                                </p>
                            </div>
                        </div>
                    </button>
                ))}
                <button
                    onClick={() => onSend('__ADD_USERS__')}
                    className="quick-panel__option quick-panel__option--admin"
                >
                    <div className="quick-panel__option-inner">
                        <FileText className="quick-panel__option-icon" />
                        <div>
                            <h3 className="quick-panel__option-title">
                                Agregar usuarios a este Proyecto
                            </h3>
                            <p className="quick-panel__option-subtitle">
                                Administrar usuarios del proyecto
                            </p>
                        </div>
                    </div>
                </button>
                <button
                    onClick={() => onSend('__MODIFY_CALENDAR__')}
                    className="quick-panel__option quick-panel__option--admin"
                >
                    <div className="quick-panel__option-inner">
                        <FileText className="quick-panel__option-icon" />
                        <div>
                            <h3 className="quick-panel__option-title">
                                Modificar Calendario de Notificaciónes
                            </h3>
                            <p className="quick-panel__option-subtitle">
                                Administrar Notificaciónes
                            </p>
                        </div>
                    </div>
                </button>
            </div>
        </div>
    );
};
